import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import StorefrontIcon from '@mui/icons-material/Storefront';
import WebIcon from '@mui/icons-material/Web';

export const ProcessingTypeIcons: {[_: string]: any} = {
  cardPresent: <StorefrontIcon />,
  cardNotPresent: <PhoneInTalkIcon />,
  eCommerce: <WebIcon />,
};
